import * as React from 'react';
import { Link } from 'react-router-dom';

interface HeroSectionProps {
  title: string;
  backgroundImage: string;
}

export function HeroSection({ title, backgroundImage }: HeroSectionProps) {
  const scrollToHowItWorks = (e: React.MouseEvent) => {
    e.preventDefault();
    const howItWorksSection = document.getElementById('how-it-works');
    if (howItWorksSection) {
      howItWorksSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="flex flex-col font-bold text-white w-full">
      <div className="relative flex w-screen sm:w-full h-screen max-h-[550px] sm:max-h-[673px] max-md:min-h-[450px] overflow-hidden">
        <img
          loading="lazy"
          src={backgroundImage}
          alt=""
          className="object-cover absolute inset-0 w-full h-full z-0"
        />
        <div className="relative flex flex-col justify-center items-center w-full h-full bg-black bg-opacity-40 text-center px-4 py-8 sm:p-6">
          <h1 className="text-3xl sm:text-4xl md:text-5xl tracking-tighter leading-tight font-extrabold mb-2 sm:mb-0">
            Transforming Venture Capital
          </h1>
          <p className="mt-2 sm:mt-4 text-base sm:text-lg md:text-xl max-w-xs sm:max-w-lg font-normal">
            Streamline capital raising, enable fractional ownership, and create liquidity for your investors through blockchain technology.
          </p>
          <div className="flex flex-col gap-3 sm:gap-4 mt-6 sm:mt-8 items-center justify-center w-full max-w-[320px] sm:max-w-md">
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 w-full">
              <Link to="/sales/create-fund" className="w-full sm:w-1/2">
                <button
                  className="flex justify-center items-center py-3 sm:p-4 text-sm sm:text-base rounded-md bg-[#6741c6] hover:bg-[#5536a5] transition-all duration-300 w-full font-medium shadow-md"
                  aria-label="Tokenize Your Fund"
                >
                  <span className="text-center">Tokenize Your Fund</span>
                </button>
              </Link>
              <button
                onClick={scrollToHowItWorks}
                className="flex justify-center items-center py-3 sm:p-4 text-sm sm:text-base rounded-md border-2 border-white bg-transparent hover:bg-white hover:text-[#6741c6] transition-all duration-300 w-full sm:w-1/2 font-medium shadow-md"
                aria-label="See How It Works"
              >
                <span className="text-center">See How It Works</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
